
<script>
import {redirect, stripTags} from "../../utility"
import {loading} from "../../core/page-loader"

export default {
    el: '#start-wrapper',
    name: "StartCalculation",
    data() {
        return {
            questionGewerke: {},
            questionEventsIndoor: {},
            questionEventsOutdoor: {},
            mode: "new",
            eventType: 'indoor'
        }
    },
    created() {
        this.questionGewerke = question_gewerke
        this.questionEventsIndoor = question_event_indoor
        this.questionEventsOutdoor = question_event_outdoor
        this.mode = start_mode
    },
    mounted() {
        if(this.mode === "new") {
            this.initGewerke()
        }

        $(document).on('click',  (e) =>  {
            if ($(e.target).parents().is('.trades-slider')) {
                if ($(e.target).parents().is('.slick-slide')) {
                    let dataValue = $(e.target).parents('.slick-slide').data().value
                    let dataQuestionId = $(e.target).parents('.slick-slide').data().questionId
                    let dataAnswerId = $(e.target).parents('.slick-slide').data().answerId
                    let dataAnswerHeadline = $(e.target).parents('.slick-slide').data().headline
                    this.startCalculation(dataQuestionId, dataAnswerId, dataValue, dataAnswerHeadline)
                }
            }
        })

        this.$el.style.visibility = 'visible'
    },
    methods: {
        initGewerke() {
            this.$nextTick(() => {
                // Gewerke Slider
                $('.trades-slider, .samples-slider').slick({
                    lazyLoad: 'progressive',
                    slidesToShow: 5,
                    infinite: true,
                    speed: 200,
                    useCSS: false,
                    slidesToScroll: 1,
                    waitForAnimate: false,
                    centerPadding: '20px',
                    swipeToSlide: true,
                    prevArrow: '<button class="prevArrow" type="button"><img src="images/arrowLeft_lightblue.svg" /></button>',
                    nextArrow: '<button class="nextArrow" type="button"><img src="images/arrowRight_lightblue.svg" /></button>',
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                centerPadding: '70px',
                                slidesToShow: 4
                            }
                        },
                        {
                            breakpoint: 1080,
                            settings: {
                                centerPadding: '70px',
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                centerPadding: '70px',
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 562,
                            settings: {
                                centerMode: true,
                                centerPadding: '0px',
                                slidesToShow: 1,
                                adaptiveHeight: true,
                            }
                        }
                    ]
                })
            })

        },
        changeMode(mode) {
            this.mode = mode
            if(this.mode === "new") {
                this.initGewerke()
            } else {
                $('.trades-slider').unslick()
            }
        },
        continueCalculation(event) {
            event.preventDefault()
            event.target.innerHTML = 'Loading...'
            loading(true)

            redirect("/eventcalculator")
        },

        startCalculation(question, answer, value, headline) {
            $('#main').css('pointer-events','none')
            
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'calculationStarted',
                tradeName: stripTags(headline)
            });
            
            axios.post('calculation/start', {
                prefills: [{
                    question_id: question,
                    answer_id: answer,
                    value: value
                }]
            }).then(function (response) {
                redirect("/eventcalculator/"+response.data.public_id)
            })
        },
        switchEventType(newType) {
            if(this.eventType !== newType) {
                this.eventType = newType
            }
        }
    },
    computed: {
        eventTypeData() {
            if(this.eventType === 'indoor') {
                return this.questionEventsIndoor
            }

            return this.questionEventsOutdoor
        }
    }
}
</script>